import { redirect } from 'react-router';
import { jwtDecode, JwtPayload } from 'jwt-decode';

export function getAuthUser() {
	const user = localStorage.getItem('user');
	if (!user) {
		return redirect('/login');
	}
	return user;
}

export function loginLoader() {
	const user = localStorage.getItem('user');

	if (user) {
		return redirect('/');
	}

	return null;
}

export const isTokenExpired = (
	token?: string | null
): boolean => {
	if (!token) return true;

	try {
		const decodedToken = jwtDecode<JwtPayload>(token);
		const currentTime = Date.now() / 1000;

		return decodedToken.exp
			? decodedToken.exp < currentTime
			: true;
	} catch (error) {
		return true;
	}
};
